import { FileService } from "projects/services/src/app/API/document/file.service";
import { Helpers } from "projects/training-calendar/src/app/helpers";
import { LoadingService } from "projects/services/src/app/loading.service";
import {
	Component,
	OnInit,
	OnChanges,
	Output,
	EventEmitter,
	Input,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { ApiService } from "projects/services/src/app/API/api.service";
import { CurrentUserService } from "projects/services/src/app/current-user.service";
import { FormGroup } from "@angular/forms";
import { SharedService } from "projects/services/src/app/shared/shared.service";
import {
	ValidationService,
	isValidS3Url,
} from "projects/services/src/app/validation.service";
import { flatMap, forkJoin, map } from "rxjs";
// import { FileService } from 'projects/services/src/app/API/document/file.service';

declare var toastr: any;
// import * as toastr from 'toastr';
toastr.options = { timeOut: 8000 };
const DEFAULT = Object.freeze({
	KEY: "nsdc",
	FILE_TYPE: "doc",
});
const DEFAULT_CATEGORIESED_VALUE = Object.freeze({
	// _type: 'CATEGORISED',
});

const STRING = Object.freeze({
	EMPTY_STRING: "",
	FILE: "file",
	CHOOSE_FILE: "Choose file",
	PLUS: "+",
	FORWARD_SLASH: "/",
	UNDERSCORE: "_",
	THREE_DOT: "...",
	S3_BASE_URL: "http://nsdcdev.s3.amazonaws.com/",
	DOT_COM_SLASH: ".com/",
	DOT_COMMA: ".,",
	LOCATION: "Location",
	HTTP_PROTOCOL: environment.amazonS3 + "://" || "http://",
	S3_URL_POSTFIX: ".s3.amazonaws.com/",
	ZERO: "0",
	STRING: "string",
});

const UPLOAD_STATUS = Object.freeze({
	INIT: "init",
	SELECTED: "selected",
	UPLOADED: "uploaded",
});

export const UPLOAD_TYPE = Object.freeze({
	CATEGORISED: "categorised",
});

const MESSAGES = Object.freeze({
	UPLOADING_WITHOUT_SELECT: "Please Select File",
	SELECT_APPROPRIATE_TYPE: "Please Select Appropriate type",
});
@Component({
	selector: "app-upload-file",
	templateUrl: "./upload-file.component.html",
	styleUrls: ["./upload-file.component.css"],
})
export class UploadFileComponent implements OnInit, OnChanges {
	@Input() value: any; // s3 url(2 way binding availab)             ---------------------------------required
	// tslint:disable-next-line:max-line-length
	@Input() localFile: string; // (2 way binding)                       ---------------------------------required(if you want persist image name on view)
	@Input() localFileValue: string; // (2 way binding)                     ---------------------------------required(if you want persist image name on view)
	@Input() formValue: any; // If you are using Form Control      ---------------------------------optional
	@Input() fileType: string = DEFAULT.FILE_TYPE; // which will append to url for getting policy ----------------------------required
	@Input() info = STRING.EMPTY_STRING; // message for further information ex:- only pdf, jpeg--------------------optional
	@Input() validationFunctions: any; // If you are not using formControl and still want validations  ---optional
	@Input() name = STRING.FILE;
	@Input() showAstrisk = true;
	@Input() disabled = false;
	@Input() uploadType: string;
	@Input() api = `/api/document/v2`;
	@Input() tableLabel = {
		sno: "S.NO",
		categoryName: "S.No",
		file: "File Name",
		action: "Action",
	};
	@Input() placeholder:any = STRING.CHOOSE_FILE;
	@Input() isMultiSelect = false;
	@Input() allowedFormats: any = ".pdf,.jpeg,.jpg,.png,.xlsx,.docx,.xls,.mp4";
	@Input() documentTemplateUrl: string;
	@Input() isPublicTemplateUrl: string;
	@Input() inlineUploadStyle = false;
	@Input() isReviewRequiredSelect = false;
	categorisedFileDetails: any = [];
	private _status: string;
	@Input() dropDownDivClass = "col-md-2";
	@Input() fileInputDivClass = "col-md-10";
	@Input() categories = [];
	@Input() selectedCategory = STRING.EMPTY_STRING;
	@Input() isFileSelect: any;
	@Input() maxFileUpload: any;
	@Input() s3CustomPathDetails: { status: boolean; s3CustomPath: string } = {
		status: false,
		s3CustomPath: "",
	};
	temp = {
		placeholder: STRING.CHOOSE_FILE,
	};
	visible = true;
	showIcon = false;
	previewPhotos: any[];
	isdisabled = false;
	// status: string;
	apiV3 = 'api/document/v3?role=Candidate'
	get status() {
		if (this.isCategorised) {
			let error: any =
				ValidationService.categorisedFileSelectedNotUploaded()(
					this.formValue
				);
			if (error) {
				this._status = this.STATUS.SELECTED;
			}
			error =
				!this.value ||
				!this.value[this.selectedCategory] ||
				!this.value[this.selectedCategory].length;
			// error = ValidationService.categorisedFileRequired(requiredRule)(this.formValue);
			if (error) {
				this._status = this.STATUS.INIT;
			}
		}
		return this._status;
	}
	set status(status) {
		if (this.isCategorised) {
			const requiredRule = this.categories.map((cat) => ({
				[cat]: true,
			}));
			let error: any =
				ValidationService.categorisedFileSelectedNotUploaded()(
					this.formValue
				);
			if (error) {
				this._status = this.STATUS.SELECTED;
				return;
			}
			error =
				!this.value ||
				!this.value[this.selectedCategory] ||
				!this.value[this.selectedCategory].length;
			// error = ValidationService.categorisedFileRequired(requiredRule)(this.formValue);
			if (error) {
				this._status = this.STATUS.INIT;
				return;
			}
		}
		this._status = status;
	}
	get STATUS() {
		return UPLOAD_STATUS;
	}
	fileSelected = false;
	@Output() blur = new EventEmitter();
	@Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
	@Output()
	localFileChange: EventEmitter<string> = new EventEmitter<string>();
	@Input() withoutButton = false;
	@Output() localFileValueChange: EventEmitter<any> = new EventEmitter<any>();
	blurred = true;
	error: string;
	errors: string[];
	fileSize: any;
	@Input() fileSizeRestrict = 5;
	loggedInUser: any;
	policy: any;
	signature: any;
	accessKey: any;
	bucket: any;
	uuid: any;
	fileUploaded: any;
	uploadFromServerOnly = true;

	fileDetail: any = {
		name: STRING.EMPTY_STRING,
	};
	fileDetails: any = [];

	@Input() modifyFileName: { name: string } = { name: STRING.EMPTY_STRING };
	@Input() modifyFileStatus = false;

	constructor(
		private loadingService: LoadingService,
		private apiService: ApiService,
		private currentUserService: CurrentUserService,
		private sharedService: SharedService,
		private fileService: FileService
	) {
		this.sharedService.subject.subscribe((iconStatus) => {
			this.showIcon = iconStatus;
		});
	}
	isCategoryDisabled() {
		return null;
	}

	get isCategorised() {
		return (
			this.uploadType === UPLOAD_TYPE.CATEGORISED ||
			(this.categories && this.categories.length)
		);
	}

	ngOnChanges(changes) {
		console.log(
			"upload type, categories",
			this.uploadType,
			this.categories,
			changes
		);
		if (changes && changes.value) {
			try {
				const isSame = Helpers.compareObj(
					changes.value.currentValue,
					changes.value.previousValue
				);
				if (!isSame) {
					// if (this.placeholder === "Choose Unisex Washroom Room Photos") {
					// 	console.log("inside text")
					// }
					this.ngOnInit();
				}
			} catch (e) {
				console.warn(e);
			}
		}
	}

	get disAllow() {
		return this.isCategorised &&
			this.selectedCategory === STRING.EMPTY_STRING
			? true
			: false;
	}

	clearSelectedCategorisedFiles() {
		const categorisedFiles = this.value || {};
		const categories = Object.keys(categorisedFiles);
		categories.map((category: any) => {
			const files = categorisedFiles[category] || [];
			const filteredFiles = [];
			files.map((file) => {
				if (isValidS3Url(file)) {
					const selectedCategory = this.categories.find(
						(c) => c.toString() === category
					);
					if (selectedCategory) {
						selectedCategory.enable = false;
					}
					filteredFiles.push(file);
				}
			});
			categorisedFiles[category] = filteredFiles;
		});
		this.mapfilesToCategoriseFile();
	}

	onCategoryChange() {
		this.fileDetails = [];
		this.clearSelectedCategorisedFiles();
	}

	ngOnInit() {
		if (this.placeholder === "Choose Unisex Washroom Room Photos") {
			console.log("inside text");
		}
		this.currentUserService.getCurrentUser().subscribe(res => {
			this.loggedInUser = res;
		})
		this.fileDetail.name = ""; // this.localFile;
		this.fileDetail.file = this.localFileValue;
		this.fileDetail.types = this.info;
		this.categories = this.categories || [];
		// this.temp.placeholder = this.placeholder || this.temp.placeholder;
		if (this.formValue) {
			this.formValue.valueChanges.subscribe(
				this.onFormValueChange.bind(this)
			);
		}
		if (this.allowedFormats instanceof Array) {
			this.allowedFormats = "." + this.allowedFormats.join(",.");
		}
		this.dropDownDivClass = this.isCategorised
			? this.dropDownDivClass
			: "display-none";
		this.fileInputDivClass = this.fileInputDivClass || "col-md-12";
		this.setReceivedValue();
		this.valueChange.emit(this.value);
	}

	private setReceivedValue() {
		if (this.placeholder === "Choose Unisex Washroom Room Photos") {
			console.log("inside text");
		}
		if (this.isCategorised) {
			this.value = this.value || {};
			const value = {};
			this.categories.map((category) => {
				value[category] = this.value[category] || [];
			});
			this.value = value;
		}
		if (this.value && this.value.length) {
			this.status = this.STATUS.UPLOADED;
			if (this.formValue) {
				this.formValue.setValue(this.value);
				this.showIcon = true;
			}
			if (this.isCategorised) {
				this.mapfilesToCategoriseFile();
			} else if (this.isMultiSelect) {
				this.fileDetails = this.value.map((s3Url) => {
					return {
						name: this._deriveNameFromS3Url(s3Url),
					};
				});
			} else {
				this.fileDetail.name = this._deriveNameFromS3Url(this.value);
				this.placeholder = this.trimFileName(this.fileDetail.name);
			}
			this.fileUploaded = true;
		} else {
			this._emptyEverything();
		}
	}

	private mapfilesToCategoriseFile() {
		this.categorisedFileDetails = this.categories.map((category) => {
			return {
				name: category,
				fileDetails: (this.value[category] || []).map((fileName) => ({
					name: this._deriveNameFromS3Url(fileName),
				})),
				fileNames: (this.value[category] || []).map(
					this._deriveNameFromS3Url
				),
				downloadUrls: this.value[category] || [],
			};
		});
	}

	deleteCategoryUrls(category) {
		this.value[category] = [];
		category.enable = true;
		this.formValue.setValue(this.value);
		this.setCategoryValue(category, []);
		this.mapfilesToCategoriseFile();
	}

	private _deriveNameFromS3Url(s3Url) {
		const s3UrlData = s3Url.split(STRING.FORWARD_SLASH);
		const fullName = s3UrlData[s3UrlData.length - 1];
		const nameData = fullName && fullName.split(STRING.UNDERSCORE);
		nameData.splice(0, 1);
		const name = nameData.join(STRING.UNDERSCORE);
		// const name = nameData &&  nameData[nameData.length - 1];
		return name;
	}

	private isValidFileUrl(fileUrl: string) {
		return (
			fileUrl &&
			typeof fileUrl === STRING.STRING &&
			fileUrl.indexOf(ValidationService.CONST.FILE_DIFFERENCIATOR) !== 0
		);
	}
	resetInput() {
		this.visible = false;
		setTimeout(() => (this.visible = true));
	}

	onFormValueChange(val) {
		if (this.placeholder === "Choose Unisex Washroom Room Photos") {
			console.log("inside text");
		}
		if (val == null) {
			this.resetInput();
		}
		if (this.value === val) {
			// this.placeholder = this.temp.placeholder;
			return;
		}
		if (val === STRING.EMPTY_STRING || val === null) {
			this._emptyEverything();
		}
		if (this.isCategorised) {
			this.value = val;
			// this.valueChange.emit(val);
		}
		if (this.isValidFileUrl(val)) {
			this.value = val;
			this.showIcon = true;
			this.status = this.STATUS.UPLOADED;
			this.fileUploaded = true;
			this.fileDetail.name = this._deriveNameFromS3Url(this.value);
			this.placeholder = this.trimFileName(this.fileDetail.name);
		}
		// if (this.value === val || !this.isValidFileUrl(val)) {
		// 	return;
		// }
		// if (!val && this.fileDetail.name !== val) {
		// 	this._emptyEverything();
		// } else {
		// 	this.value = val;
		// 	this.status = this.STATUS.UPLOADED;
		// 	if (this.formValue) {
		// 		// this.formValue.setValue(this.value);
		// 		this.showIcon = true;
		// 	}
		// 	this.fileDetail.name = this._deriveNameFromS3Url(this.value);
		// 	this.placeholder = this.trimFileName(this.fileDetail.name);
		// 	this.fileUploaded = true;
		// }
		// else {
		// 	this.value = val;
		// 	this.status = this.STATUS.UPLOADED;
		// 	if (this.formValue) {
		// 		this.formValue.setValue(this.value);
		// 		this.showIcon = true;
		// 	}
		// 	this.fileDetail.name = this._deriveNameFromS3Url(this.value);
		// 	this.placeholder = this.trimFileName(this.fileDetail.name);
		// 	this.fileUploaded = true;
		// }
	}

	get multiselect() {
		return this.isMultiSelect ? STRING.EMPTY_STRING : null;
	}

	private _runValidationFunctions(validationFunctions, value) {
		let finalError = null;
		for (const fnc of validationFunctions) {
			if (typeof fnc !== "function") {
				console.warn(
					"Please pass only functions of Array To validationFunctions"
				);
				continue;
			}
			const err = fnc({ value });
			if (err) {
				finalError = finalError
					? Object.assign(finalError, err)
					: Object.assign({}, err);
			}
		}
		return finalError ? finalError : {};
	}

	onBlur() {
		// this.visible = false;
		// setTimeout(() => this.visible = true, 1);
		if (this.formValue && this.blurred) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
		this.blur.emit();
	}

	trimFileName(fileName) {
		return Helpers.trimFileName(fileName);
		// const length = fileName.length;
		// if (length < 20) {
		// 	return fileName;
		// }
		// const startString = fileName
		// 	.split(STRING.EMPTY_STRING)
		// 	.slice(0, 10)
		// 	.join(STRING.EMPTY_STRING);
		// const endString = fileName
		// 	.split(STRING.EMPTY_STRING)
		// 	.slice(length - 7, length)
		// 	.join(STRING.EMPTY_STRING);
		// return startString + STRING.THREE_DOT + endString;
	}

	onChange(event) {
		if (this.isMultiSelect) {
			if (this.isCategorised) {
				console.log(
					"upload type, categories",
					this.uploadType,
					this.categories
				);
				return this.onChangeCategorisedFiles(event);
			}
			return this.onChangeRefact(event);
		}
		const fileList: FileList = event.target.files;
		const fil = event.target.files[0];
		const name = fil["name"];
		const nameChange = fil.slice(0, fil.size, fil.type);
		const newFile = new File(
			[nameChange],
			name.replace(/[^\w \s xdff_.]/gi, ""),
			{ type: fil.type }
		);
		const fileData = newFile;
		if (!fileData) {
			return;
		}
		let fileName: string = event.target.files[0].name;
		fileName = this.trimFileName(fileName);
		this.fileDetail.name = fileName;
		this.placeholder = Helpers.trimFileName(this.fileDetail.name);
		this.fileUploaded = false;
		let errors: any = {};
		if (this.validationFunctions) {
			if (!(this.validationFunctions instanceof Array)) {
				this.validationFunctions = [this.validationFunctions];
			}
			errors = this._runValidationFunctions(
				this.validationFunctions,
				this.fileDetail.name
			);
		}
		if (this.formValue) {
			this.formValue.setValue(
				ValidationService.CONST.FILE_DIFFERENCIATOR +
				this.fileDetail.name
			);
			let formError = this.formValue.errors;
			errors = formError ? Object.assign(errors, formError) : errors;
			this.formValue.setValue(fileData);
			formError = this.formValue.errors;
			errors = formError ? Object.assign(errors, formError) : errors;
		}
		if (errors && (errors.fileType || errors.fileSize)) {
			this.fileDetail.file = null;
			this.fileDetail.name = STRING.EMPTY_STRING;
			let error:any = STRING.EMPTY_STRING;
			if (errors.fileType) {
				error = MESSAGES.SELECT_APPROPRIATE_TYPE;
			}
			if (errors.fileSize) {
				error = `File size should not be more than ${errors.maxSizePayload} MB`;
			}
			this.showError(error);
			return;
		}
		this.value = fileName;
		const file: File = fileData;
		this.fileDetail.file = file;
		this.onFileSelectComplete(file.name, file);
		if (this.withoutButton) {
			this.upload();
		}
	}

	clearError() {
		this.showError(STRING.EMPTY_STRING);
		this.showError([]);
	}

	showError(errorMessage: any) {
		if (errorMessage instanceof Array) {
			return (this.errors = errorMessage);
		}
		this.error = errorMessage;
	}

	onBeforeUpload() {
		this.loadingService.blockUI();
	}

	onCategorisedUploadComplete(fileName, s3Url) {
		this.loadingService.unblockuI();
		this.value[this.selectedCategory] = s3Url;
		if (this.formValue) {
			this.formValue.setValue(this.value);
		}
		// if (s3Url instanceof Array) {
		// 	this.fileDetails.map((fd, i) => {
		// 		fd.s3Url = s3Url[i];
		// 	});
		// } else {
		// 	this.fileDetail.s3Url = s3Url;
		// }
		toastr.success(`${fileName} file uploaded successfully`);
		this.fileUploaded = true;
		this.showIcon = true;
		// if (this.modifyFileStatus) {
		// 	this.fileDetail.name = this.modifyFileName.name;
		// }
		// if (this.isCategorised) {
		// 	this.categorisedValue[this.selectedCategory] = this.value;
		// }
		this.valueChange.emit(this.value);
		this.clearSelectedCategorisedFiles();
		this.status = this.STATUS.UPLOADED;
	}

	onUploadComplete(fileName, s3Url) {
		if (this.isReviewRequiredSelect) {
			this._getS3Urls(s3Url).then((S3URL) => {
				this.previewPhotos = S3URL;
			});
			console.log("s33333333333333333333333", this.previewPhotos);
		}
		if (this.isCategorised) {
			return this.onCategorisedUploadComplete(fileName, s3Url);
		}
		this.loadingService.unblockuI();
		if (this.formValue) {
			this.formValue.setValue(s3Url);
		}
		if (s3Url instanceof Array) {
			this.fileDetails.map((fd, i) => {
				fd.s3Url = s3Url[i];
			});
		} else {
			this.fileDetail.s3Url = s3Url;
		}
		toastr.success(`${fileName} file uploaded successfully`);
		this.fileUploaded = true;
		this.showIcon = true;
		if (this.modifyFileStatus) {
			this.fileDetail.name = this.modifyFileName.name;
		}
		this.valueChange.emit(s3Url);
		this.status = this.STATUS.UPLOADED;
	}

	onFileSelectComplete(fileNames, files) {
		// this._emptyEverything();
		this.localFile = fileNames;
		this.localFileValue = files;
		this.localFileChange.emit(this.localFile);
		this.localFileValueChange.emit(this.localFileValue);
		this.clearError();
		this.fileSelected = true;
		this.status = this.STATUS.SELECTED;
		this.resetInput();
		if (this.maxFileUpload !== undefined) {
			if (files.length > this.maxFileUpload) {
				this.isdisabled = true;
				toastr.error(`please select maximum ${this.maxFileUpload} files`);
			} else {
				this.isdisabled = false;
			}
		}
		if (this.isFileSelect) {
			if (files.length < 5) {
				this.disabled = true;
				toastr.error("please select at least 5 photographs");
			} else {
				this.disabled = false;
			}
		}
	}

	onChangeCategorisedFiles(event) {
		let files = event.target.files;
		files = Array.prototype.map.call(files, (file) => file);
		if (!files.length) {
			return;
		}
		const fileNames = Array.prototype.map
			.call(files, (file) => file.name)
			.map(
				(fileName) =>
					ValidationService.CONST.FILE_DIFFERENCIATOR + fileName
			);
		let errors: any = {};
		if (this.formValue) {
			const categorisedFileNames = {
				[this.selectedCategory]: fileNames,
			};
			const categorisedFile = {
				[this.selectedCategory]: files,
			};
			this.value = this.value || {};
			Object.assign(this.value, categorisedFileNames);
			this.formValue.setValue(this.value);
			Object.assign(this.value, categorisedFile);
			const nameErrors = this.formValue.errors || {};
			this.formValue.setValue(this.value);
			const sizeErrors = this.formValue.errors || {};
			errors = Object.assign(errors, nameErrors, sizeErrors);
		}
		const errorList = [];
		for (const error in errors) {
			if (errors[error]) {
				errorList.push(errors[error]);
			}
		}
		const errorMessages = errorList
			.map((error) => error.payloadMessage)
			.filter((message) => message);
		if (errorMessages.length) {
			return this.showError(errorMessages);
		}
		// this.value = this.isCategorised ? Object.assign(this.value) || fileNames;
		this.value[this.selectedCategory] = fileNames;
		this.fileDetails = [];
		files.map((file) => {
			// this.setCategoryValue(this.selectedCategory, file);
			this.fileDetails.push({
				name: file.name,
				file: file,
			});
		});
		this.setCategoryValue(this.selectedCategory, this.fileDetails);
		this.onFileSelectComplete(fileNames, files);
	}

	private setCategoryValue(categoryName, value) {
		let category = this.categorisedFileDetails.find(
			(c) => c.name === categoryName
		);
		if (!category) {
			category = {
				name: categoryName,
				fileDetails: [],
			};
			this.categorisedFileDetails.push(category);
		}
		category.fileDetails = value;
	}

	onChangeRefact(event) {
		let files = event.target.files;
		files = Array.prototype.map.call(files, (file) => file);
		if (!files.length) {
			return;
		}
		const fileNames = Array.prototype.map.call(files, (file) => file.name);
		const trimmedFileNames = fileNames.map((fileName) =>
			this.trimFileName(fileName)
		);
		let errors: any = {};
		if (this.formValue) {
			if (this.isCategorised) {
				const categorisedFileNames = {
					[this.selectedCategory]: fileNames,
				};
				const categorisedFile = {
					[this.selectedCategory]: files,
				};
				Object.assign(this.value, categorisedFileNames);
				this.formValue.setValue(this.value);
				Object.assign(this.value, categorisedFile);
				const nameErrors = this.formValue.errors || {};
				this.formValue.setValue(this.value);
				const sizeErrors = this.formValue.errors || {};
				errors = Object.assign(errors, nameErrors, sizeErrors);
			} else {
				this.formValue.setValue(fileNames);
				const nameErrors = this.formValue.errors || {};
				this.formValue.setValue(files);
				const sizeErrors = this.formValue.errors || {};
				errors = Object.assign(errors, nameErrors, sizeErrors);
			}
		}
		const errorList = [];
		for (const error in errors) {
			if (errors[error]) {
				errorList.push(errors[error]);
			}
		}
		const errorMessages = errorList
			.map((error) => error.payloadMessage)
			.filter((message) => message);
		if (errorMessages.length) {
			return this.showError(errorMessages);
		}
		this.value = fileNames;
		this.fileDetails = [];
		files.map((file) => {
			this.fileDetails.push({
				name: file.name,
				file: file,
			});
		});
		this.onFileSelectComplete(fileNames, files);
	}

	uploadRefact() {
		const files = this.fileDetails.map((fileDetail) => fileDetail.file);
		if (!files || !files.length) {
			const error = MESSAGES.UPLOADING_WITHOUT_SELECT;
			this.showError(error);
			return;
		}

		const policyUrlKeys = this.fileDetails.map((fileDetail) => {
			return this.getPolicyUrl(fileDetail.file);
		});
		return forkJoin(policyUrlKeys).pipe(flatMap(this.uploadFiles.bind(this)));
	}

	getPolicyUrl(file) {
		const uploadThis = this;
		const key = DEFAULT.KEY;
		const getpolicyURL = `${environment.documentServiceUrl}
								/api/document/v1?key=${key}
								/${this.loggedInUser.role}
								/${this.loggedInUser.userName}
								/${this.fileType}`;
		return this.apiService
			.get(getpolicyURL, {
				contentType: file.type,
			})
			.pipe(map((res) => ({
				policy: res.Policy,
				signature: res.Signature,
				accessKey: res.Key,
				bucket: res.Bucket,
				uuid: res.Uuid,
				userName: uploadThis.loggedInUser.userName,
				userRole: uploadThis.loggedInUser.role,
				fileName: file.name,
				files: file,
				fileType: uploadThis.fileType,
			})));
	}

	download(fileURL) {
		if (this.isPublicTemplateUrl) {
			return this.fileService.downloadFromUrl(fileURL);
		}
		this.fileService.downloadAttachedFile(fileURL);
		// if (fileURL) {
		// 	fileURL = fileURL.split('.com/').pop();
		// 	const documentDOwnloadURL =
		// 		environment.documentServiceUrl +
		// 		'/api/document/v1/signedURL?key=' +
		// 		fileURL;
		// 	this.apiService.get(documentDOwnloadURL).subscribe(signedURL => {
		// 		const a = document.createElement('a');
		// 		document.body.appendChild(a);
		// 		a.setAttribute('style', 'display: none');
		// 		a.href = signedURL;
		// 		a.download = signedURL.filename;
		// 		a.click();
		// 		window.URL.revokeObjectURL(signedURL);
		// 		a.remove(); // remove the element
		// 	});
		// }
	}

	uploadFiles(creds) {
		const formsData = creds.map((cred) => {
			return this.creatFormData(cred);
		});
		const uploadArray = formsData.map((formData, index) => {
			const url =
				STRING.HTTP_PROTOCOL +
				creds[index].bucket +
				STRING.S3_URL_POSTFIX;
			return this.apiService.fileUpload(url, formData);
		});
		return forkJoin(uploadArray).pipe(map((uploads:any) =>
			uploads.pipe(map((upload: any) =>
				upload.headers
					.get(STRING.LOCATION)
					.split(STRING.DOT_COM_SLASH)
					.pop()
			)
		)));
	}

	upload() {
		this.previewPhotos = [];
		if (
			this.uploadFromServerOnly ||
			environment.functionalities.uploadFromServer
		) {
			// if (environment.functionalities.uploadFromServer) {
			return this.uploadV2();
		}
		if (this.error) {
			toastr.error(this.error);
		} else {
			if (this.isMultiSelect) {
				this.loadingService.blockUI();
				return this.uploadRefact().subscribe((res: any) => {
					this.onUploadComplete(res.length, res);
				});
			}
			const file: File = this.fileDetail.file;
			if (!file) {
				this.loadingService.unblockuI();
				const err = "Please Select File";
				this.showError(err);
				return;
			}
			// tslint:disable-next-line:max-line-length
			const getpolicyURL =
				environment.documentServiceUrl +
				"/api/document/v1?key=prashanthtest/" +
				this.loggedInUser.role +
				"/" +
				this.loggedInUser.userName +
				"/" +
				this.fileType;
			this.apiService
				.get(getpolicyURL, {
					contentType: file.type,
				})
				.subscribe(
					(res) => {
						this.policy = res.Policy;
						this.signature = res.Signature;
						this.accessKey = res.Key;
						this.bucket = res.Bucket;
						this.uuid = res.Uuid;
						this.uploadFile(
							this.loggedInUser.userName,
							this.loggedInUser.role,
							file
						);
					},
					(err) => {
						// error
						this.loadingService.unblockuI();
					}
				);
		}
	}

	uploadFile(userName, userRole, files) {
		const formData = this.creatFormData({
			userName,
			userRole,
			fileName: files.name,
			policy: this.policy,
			signature: this.signature,
			accessKey: this.accessKey,
			files,
			fileType: this.fileType,
			uuid: this.uuid,
		});
		const url = STRING.HTTP_PROTOCOL + this.bucket + STRING.S3_URL_POSTFIX;

		this.apiService.fileUpload(url, formData).subscribe(
			(res) => {
				this.loadingService.unblockuI();
				const s3Url = res.headers
					.get(STRING.LOCATION)
					.split(STRING.DOT_COM_SLASH)
					.pop();
				// .replace(STRING.S3_BASE_URL, STRING.EMPTY_STRING);
				this.onUploadComplete(files.name, s3Url);
			},
			(err) => {
				this.loadingService.unblockuI();
			}
		);
	}

	uploadMultiV2(): any {
		const files: File[] = this.fileDetails.map((d) => d.file);
		if (!files || !files.length) {
			this.loadingService.unblockuI();
			const err = "Please Select File";
			this.showError(err);
			return;
		}
		const uploadObservables = [];
		for (const file of files) {
			uploadObservables.push(this.uploadToServerV2(file));
			console.log("data===============>", uploadObservables);
		}
		return forkJoin(uploadObservables);
	}

	uploadV2() {
		if (this.error) {
			toastr.error(this.error);
		}
		if (this.isMultiSelect) {
			return this.uploadMultiV2().subscribe((urls) => {
				console.log("S#URLS", urls);
				this.onUploadComplete(urls.length, urls);
			});
		}
		// this.fileDetail.file.name = this.fileDetail && this.fileDetail.file && this.fileDetail.file.name.replace(/[^\w \s _.]/gi, ""); // removed special character
		const file: File = this.fileDetail.file;
		if (!file) {
			this.loadingService.unblockuI();
			const err = "Please Select File";
			this.showError(err);
			return;
		}
		this.uploadToServerV2(file).subscribe((data) => {
			this.onUploadComplete(file.name, data);
		});
	}

	private uploadToServerV2(file: File) {
		let key = '';
		if (this.loggedInUser) {
			key =
			this.loggedInUser.role +
				"/" +
				this.loggedInUser.userName +
				"/" +
				this.fileType;
		} else {
			key = 'Candidate';
			
		}
		const types = this.allowedFormats;
		const size = this.fileSizeRestrict;
		if (this.s3CustomPathDetails.status) {
			key =
				this.s3CustomPathDetails.s3CustomPath +
				`/${this.fileDetail.name}`;
			console.log("this is file type", this.fileType);
			console.log("console.log", "this is about to upload key", key);
			console.log("This is file details", this.fileDetail);
		}
		const formData = this._createFormDataV2({
			file,
			types,
			size,
			path: key,
		});
		// const contentType = file.type;
		// const formData = this._createFormDataV2({
		// 	file,
		// 	types,
		// 	size,
		// 	contentType,
		// 	path: 'Candidate'
		// });
		// const makePublicApi = `/api/document/v3?role=Candidate`;
		// const generalApi = `/api/document/v2`;
		const URL = this.loggedInUser ? `${environment.documentServiceUrl}${this.api}` : `${environment.documentServiceUrl}/api/document/v3?role=Candidate`;
		// const URL = `${environment.documentServiceUrl}/api/document/v2`;
		// const URL = `${environment.documentServiceUrl}/api/document/v1`;
		return this.apiService.fileUpload(URL, formData).pipe(map((res) => res.body));
		// .map(url => {
		// url = {
		// 	link: url
		// };
		// return url;
		// if (url.indexOf('/') >= 0) {
		// 	// url = url.split('/').pop();
		// 	url = encodeURI(url);

		// }
		// return url;
		// });
	}

	private _createFormDataV2(data) {
		const formData = new FormData();
		if (data && data instanceof Object) {
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					formData.append(key, data[key]);
				}
			}
		}
		return formData;
	}

	private creatFormData({
		userName,
		userRole,
		fileType,
		uuid,
		fileName,
		accessKey,
		policy,
		signature,
		files,
	}) {
		const formData = new FormData();
		const contentType = files.type;
		formData.append(
			"key",
			"prashanthtest/" +
			userRole +
			"/" +
			userName +
			"/" +
			fileType +
			"/" +
			uuid +
			" / " +
			files.name
		);
		formData.append("acl", "private");
		// formData.append('Content-Type', 'image/');
		formData.append("Content-Type", contentType);
		formData.append("x-amz-meta-uuid", "1436512365127qw");
		formData.append("x-amz-server-side-encryption", "AES256");
		formData.append(
			"x-amz-credential",
			accessKey +
			"/" +
			this.buildTimestamp() +
			"/ap-south-1/s3/aws4_request"
		);
		formData.append("x-amz-algorithm", "AWS4-HMAC-SHA256");
		formData.append("x-amz-date", this.buildTimestamp() + "T000000Z");
		formData.append("x-amz-meta-tag", STRING.EMPTY_STRING);
		formData.append("policy", policy);
		formData.append("x-amz-signature", signature);
		formData.append("file", files);
		return formData;
	}

	private _emptyEverythingInCategory() {
		this.value[this.selectedCategory] = [];
		this.setCategoryValue(this.selectedCategory, []);
		if (this.formValue) {
			this.formValue.setValue(this.value);
		}
	}

	private _emptyEverything() {
		if (this.isCategorised) {
			return this._emptyEverythingInCategory();
		}
		let file: File = this.fileDetail.file;
		this.fileDetail.name = "";
		this.fileDetail.file = "";
		this.fileDetails = [];
		this.placeholder = this.temp.placeholder;
		// this.placeholder = STRING.CHOOSE_FILE;
		this.status = this.STATUS.INIT;
		file = null;
		if (this.formValue) {
			if (this.formValue.value === STRING.EMPTY_STRING) {
				return;
			}
			this.formValue.setValue("");
		}
	}

	onFileSelectOpen() {
		this._emptyEverything();
		this.blurred = false;
		const timeDealy = 1000;
		setTimeout(() => {
			this.blurred = true;
		}, timeDealy);
	}

	buildTimestamp() {
		const date = new Date();
		const year = date.getFullYear();
		const month = (STRING.ZERO + (date.getMonth() + 1)).slice(-2);
		const day = (STRING.ZERO + date.getDate()).slice(-2);
		const timestamp = year + month + day;
		return timestamp;
	}

	_getS3Urls(policyUrls: any) {
		const s3Urls = [];
		for (const policyUrl of policyUrls) {
			console.log("poli==>", policyUrl);
			if (policyUrl === "No Preview") {
				s3Urls.push(this._fakePromise(policyUrl));
				continue;
			}
			s3Urls.push(this._putS3Url(policyUrl));
		}
		return Promise.all(s3Urls);
	}

	private _fakePromise(data) {
		return new Promise((resolve, reject) => {
			return resolve(data);
		});
	}

	public _putS3Url(policy_key) {
		return new Promise((resolve, reject) => {
			this.fileService.getImageURL(policy_key).subscribe(
				(S3URL) => {
					return resolve(S3URL);
				},
				(err) => {
					return reject(err);
				}
			);
		});
	}
	checkRequired(formValue) {
		if (formValue) {
			if (formValue.errors && formValue.errors.required) {
				return true;
			}
		}
	}
}
